import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { GlobeAltOutline, UserOutline, UsersOutline } from '@bonusly/design-system';

import { Privacy } from '../types';

export const usePrivacyOptions = () => {
	const { t } = useTranslation('action_input');

	return useMemo(() => {
		return [
			{
				description: t('privacy.public_description_redesign'),
				icon: <GlobeAltOutline boxSize={4} color="text.soft" />,
				label: t('privacy.public_redesign'),
				value: Privacy.Public,
			},
			{
				description: t('privacy.team_description_redesign'),
				icon: <UsersOutline boxSize={4} color="text.soft" />,
				label: t('privacy.team_redesign'),
				value: Privacy.Team,
			},
			{
				description: t('privacy.private_description_redesign'),
				icon: <UserOutline boxSize={4} color="text.soft" />,
				label: t('privacy.private_redesign'),
				value: Privacy.Private,
			},
		];
	}, [t]);
};
